import ReactDOM from "react-dom/client";
import App from "./App";

import { Provider } from "react-redux";

import store from "./Reducers/store";
import { ThemeProvider } from "@nocios/presentation-kit";

import "./Assets/css/index.css";
import "@nocios/presentation-kit/dist/Assets/Fonts/index.css";

import setCurrentPage from "src/Utils/setCurrentPage";
import Logo from "./Component/Logo";
import HeaderCenter from "./Component/HeaderCenter";
import HeaderRight from "./Component/HeaderRight";

import Preload from "./Component/Preload";
import "./Assets/css/fonts.css";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const data = {
  base: {
    showHeaderShadow: false,
  },
  template: {
    "main-template": {
      styleTitle: {
        color: "#fff",
        fontFamily: "Tungsten",
        fontSize: "var(--width-64)",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "110%",
        textTransform: "uppercase",
      },
      styleDescription: {
        color: "#fff",
        fontFamily: "Myriad Pro",
        fontSize: "var(--width-24)",
        fontStyle: "normal",
        fontWeight: "380",
        lineHeight: "140%",
        marginTop: "var(--height-24)",
      },
      styleDescriptionUnderline: {
        color: "#fff",
        fontFamily: "Myriad Pro",
        fontSize: "var(--width-24)",
        fontStyle: "normal",
        fontWeight: "300",
        lineHeight: "100%",
        marginTop: "var(--width-8)",
      },
      styleBody: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginTop: "var(--width-50)",
      },
    },
  },
  Button: {
    base: {
      color: "#fff",
      fontFamily: "Myriad Pro",
      fontSize: "var(--width-24)",
      fontStyle: "normal",
      fontWeight: "700",
      background: "transparent",
      height: "var(--width-56)",
      border: "1px solid transparent",
      justifyContent: "center",
      lineHeight: "var(--width-32)",
      borderRadius: "var(--width-45)",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
    next: {
      background: "#fff",
      color: "#111",
    },
    back: {
      border: "1px solid #fff",
      color: "#fff",
    },
    explore: {
      color: "#000000",
      fontFamily: "Tungsten",
      fontSize: "var(--width-32)",
    },
    watch: {
      color: "#111111",
      fontFamily: "Tungsten",
      fontSize: "var(--width-32)",
    },
  },
};

const globalData = {
  header: {
    logo: <Logo />,
    rightSide: <HeaderRight />,
    centerSide: <HeaderCenter />,
    onClick: () => setCurrentPage(0),
  },
};

root.render(
  <Provider store={store}>
    <Preload>
      <ThemeProvider themeStyles={data} globalData={globalData} setPage={setCurrentPage}>
        <App />
      </ThemeProvider>
    </Preload>
  </Provider>
);
